var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 28,
    viewBox: "0 0 11 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.18659 26.8501C0.38659 27.2501 0.886589 27.4001 1.28659 27.1501C10.7366 21.3001 10.6366 7.10007 1.03659 1.40007C0.786589 1.25007 0.436589 1.35007 0.286589 1.60007C0.136589 1.85007 0.23659 2.15007 0.48659 2.30007C9.43659 7.65007 9.28659 20.4001 0.43659 25.8501C0.13659 26.0501 0.0365904 26.5001 0.18659 26.8501Z",
    fill: "url(#paint0_linear_1362_355)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.536621 4.70012C1.23662 5.25012 1.98662 5.55012 2.73662 5.70012C3.48662 5.85012 4.18662 5.75012 4.73662 5.35012C3.48662 3.70012 1.33662 3.55012 0.536621 4.70012Z",
    fill: "url(#paint1_linear_1362_355)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58667 0.700195C4.58667 1.5002 5.23667 2.5002 5.38667 3.3502C5.58667 4.2502 5.33667 4.9502 4.78667 5.4002C3.58667 3.8002 2.78667 1.8502 3.58667 0.700195Z",
    fill: "url(#paint2_linear_1362_355)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93652 7.10039C3.43652 7.75039 4.03652 8.30038 4.68652 8.60039C5.33652 8.90039 6.08652 9.05038 6.68652 8.80038C5.98652 6.85038 4.03652 6.25039 2.93652 7.10039Z",
    fill: "url(#paint3_linear_1362_355)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98656 4.1001C7.68656 5.0501 7.98656 6.1501 7.88656 7.0001C7.78656 7.8501 7.38656 8.5001 6.73656 8.7501C6.03656 7.0001 5.88656 5.0001 6.98656 4.1001Z",
    fill: "url(#paint4_linear_1362_355)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48657 9.95027C4.78657 10.7003 5.23657 11.3503 5.78657 11.8003C6.33657 12.2503 6.98657 12.6003 7.68657 12.5003C7.43657 10.5003 5.78657 9.40027 4.48657 9.95027Z",
    fill: "url(#paint5_linear_1362_355)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18639 8.15039C9.58639 9.25039 9.58639 10.3504 9.28639 11.1504C8.98639 11.9504 8.38639 12.4504 7.68639 12.5004C7.48639 10.6004 7.88639 8.70039 9.18639 8.15039Z",
    fill: "url(#paint6_linear_1362_355)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23657 13.0501C5.33657 13.8501 5.58657 14.6001 5.98657 15.2001C6.38657 15.8001 6.93657 16.2501 7.63657 16.3501C7.93657 14.3501 6.58657 12.8501 5.23657 13.0501Z",
    fill: "url(#paint7_linear_1362_355)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2367 12.5503C10.3367 13.7003 10.0367 14.7503 9.53672 15.4503C9.03672 16.1503 8.33672 16.4503 7.63672 16.3503C7.93672 14.4503 8.83672 12.7503 10.2367 12.5503Z",
    fill: "url(#paint8_linear_1362_355)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13668 16.25C4.98668 17.05 5.08668 17.85 5.28668 18.5C5.53668 19.2 5.93668 19.8 6.58668 20.1C7.38668 18.2 6.48668 16.4 5.13668 16.25Z",
    fill: "url(#paint9_linear_1362_355)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0366 17.0501C9.83662 18.2001 9.28662 19.1501 8.58662 19.6501C7.88662 20.2001 7.13662 20.3001 6.53662 20.0501C7.33662 18.3001 8.68662 16.9001 10.0366 17.0501Z",
    fill: "url(#paint10_linear_1362_355)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18643 19.3003C3.83643 20.0503 3.68643 20.8003 3.73643 21.5503C3.78643 22.3003 3.98642 23.0003 4.53642 23.4503C5.83642 21.8003 5.43643 19.8003 4.18643 19.3003Z",
    fill: "url(#paint11_linear_1362_355)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73662 21.4003C8.23662 22.4503 7.43662 23.2503 6.63662 23.6003C5.83662 23.9503 5.03662 23.9003 4.53662 23.4503C5.78662 21.9003 7.43662 20.9003 8.73662 21.4003Z",
    fill: "url(#paint12_linear_1362_355)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3867 22C1.8367 22.65 1.4367 23.35 1.2367 24.1C1.0367 24.85 1.0367 25.6 1.3867 26.15C3.2867 24.95 3.4867 22.85 2.3867 22Z",
    fill: "url(#paint13_linear_1362_355)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18672 25.3003C5.38672 26.2003 4.33672 26.7503 3.43672 26.9003C2.53672 27.0503 1.78672 26.7503 1.38672 26.2003C3.18672 25.0003 5.08672 24.4503 6.18672 25.3003Z",
    fill: "url(#paint14_linear_1362_355)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1362_355",
    x1: 9.60528,
    y1: -4.88734,
    x2: -2.83923,
    y2: -4.07939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1362_355",
    x1: 5.40309,
    y1: 3.51921,
    x2: 0.179533,
    y2: 6.00874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1362_355",
    x1: 5.80267,
    y1: -0.426117,
    x2: 2.49006,
    y2: -0.108553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1362_355",
    x1: 7.28158,
    y1: 6.19632,
    x2: 2.18363,
    y2: 7.98175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1362_355",
    x1: 8.17813,
    y1: 2.98577,
    x2: 5.56926,
    y2: 3.18418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1362_355",
    x1: 8.19436,
    y1: 9.16005,
    x2: 3.58289,
    y2: 10.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1362_355",
    x1: 9.79578,
    y1: 7.10795,
    x2: 6.97506,
    y2: 7.35638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1362_355",
    x1: 8.06636,
    y1: 12.2371,
    x2: 4.42253,
    y2: 12.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1362_355",
    x1: 10.6715,
    y1: 11.6352,
    x2: 6.75213,
    y2: 12.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1362_355",
    x1: 7.17723,
    y1: 15.3274,
    x2: 4.42047,
    y2: 15.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1362_355",
    x1: 10.592,
    y1: 16.2864,
    x2: 5.51697,
    y2: 17.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1362_355",
    x1: 5.59366,
    y1: 18.3058,
    x2: 3.15056,
    y2: 18.5009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1362_355",
    x1: 9.40309,
    y1: 20.6572,
    x2: 3.64866,
    y2: 22.5995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1362_355",
    x1: 3.36742,
    y1: 21.0055,
    x2: 0.410639,
    y2: 21.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1362_355",
    x1: 6.9484,
    y1: 24.398,
    x2: 1.00245,
    y2: 27.2623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPanel);
export default __webpack_public_path__ + "static/media/right_panel.4122fbfb1d87e5a7b1fadb8a2709d2a7.svg";
export { ForwardRef as ReactComponent };